module.exports = __webpack_public_path__ + "bb1a50e77f9bfbc5443d1f4d6c9566c6.pdf";